<template>
  <v-container>
    <v-row>
      <v-text-field v-model="Search" label="Filter by Region" outlined></v-text-field>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on">
            <v-icon dark>mdi-home-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>New Town</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="AddTown()">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="NewTown" class="pa-4">
            <v-row>
              <v-col col="12" md="3">
                <v-text-field v-model="newTown.Name" label="Name" outlined></v-text-field>
              </v-col>
              <v-col col="12" md="4">
                <v-text-field v-model="newTown.Size" label="Size" outlined></v-text-field>
              </v-col>
              <v-col col="12" md="4">
                <v-text-field v-model="newTown.Region" label="Region" outlined></v-text-field>
              </v-col>
              <v-col col="12" md="1">
                <v-checkbox v-model="newTown.Public" label="Public"></v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-textarea rows="2" v-model="newTown.Description" label="Description" outlined></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12">
                <v-textarea rows="4" v-model="newTown.Notes" label="Summary" outlined></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-hover v-for="town in filteredTowns" :key="town.id">
        <template v-slot:default="{ hover }">
          <v-card max-width="350" class="ma-4">
            <v-card-text class="pb-0 title primary--text">{{town.Name}}</v-card-text>
            <v-card-subtitle class="py-0">{{town.Description | Trim}}</v-card-subtitle>

            <v-fade-transition>
              <v-overlay v-if="hover" absolute color="#036358">
                <v-btn class="primary" :to="{ name: 'Town', params: { id: town.id } }">See more info</v-btn>
              </v-overlay>
            </v-fade-transition>
            <v-card-subtitle class="pt-0">
              Region:
              <span class="secondary--text">{{town.Region}}</span>
            </v-card-subtitle>
          </v-card>
        </template>
      </v-hover>
    </v-row>
  </v-container>
</template>

<script>
import db from "@/fb";
import { store } from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Towns",
  data: () => ({
    Towns: [],
    newTown: {},
    dialog: false,
    Search: ""
  }),
  components: {},
  methods: {
    AddTown() {
      this.newTown.PlayerId = this.playerid;
      this.newTown.CreateDate = firebase.firestore.FieldValue.serverTimestamp();
      this.newTown.UpdateDate = firebase.firestore.FieldValue.serverTimestamp();

      this.newTown.CampaignId = store.CurrentCampaign.id;

      db.collection("towns")
        .add(this.newTown)
        .then(docRef => {
          this.$router.push({ name: "Town", params: { id: docRef.id } });
        });
    }
  },
  filters: {
    Trim: function(value) {
      if (!value) return "";
      if (value.length >= 45) return value.substring(0, 45) + "...";
      return value;
    }
  },
  computed: {
    filteredTowns: function() {
      return this.Towns.filter(town => {
        if (typeof town.Region === "undefined") {
          town.Region = "";
        }
        return town.Region.toLowerCase().match(this.Search.toLowerCase());
      });
    }
  },

  firestore() {
    this.$bind(
      "Towns",
      db
        .collection("towns")
        .where("PlayerId", "==", firebase.auth().currentUser.uid)
        .where("CampaignId", "==", store.CurrentCampaign.id)
    );
  },
  created() {
    firebase.auth().onAuthStateChanged(cred => {
      this.playerid = cred.uid;
    });
  }
};
</script>
